/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
var $ = jQuery.noConflict();



$(document).ready(function () { 
    // $('body').on('touchstart', function () { });
        $('.hover').on('touchstart touchend', function (e) {
            // e.preventDefault();
            $(this).toggleClass('hover_scale');
        });


        $('.slick-slider').hide();
        TccSlider();
        console.log('document');

});




function TccSlider() {

    setTimeout(function() {
         console.log('timeout');
          $('.slick-slider').css('visibility','visible').fadeIn('slow');
    }, 1000);




  $('.collection-banners').slick({
        arrows: true,
        autoplay: true,
        autoplaySpeed: 1000,
        speed: 500,
        dots: true,
        infinite: true,
      });




    $('.chef-carousel').slick({
        arrows: true,
        autoplay: true,
        autoplaySpeed: 500,
        speed: 500,
        dots: true,
        slidesToShow: 6,
        infinite: true,
        centerMode: true,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 1360,
                settings: {
                    slidesToShow: 5
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4

                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 3,
                     dots: false
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });



    $('.cleavers-carousel').slick({
        arrows: true,
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 500,
        speed: 500,
        slidesToShow: 5,
        centerMode: true,
        variableWidth: false,
        focusOnSelect: true,
        centerPadding: '30px',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 3,
                    dots: false
                }
            }
        ]
    });


}

